import { getMinutes, getSeconds } from "../../utils/functions";

const countDowns = document.querySelectorAll(".js-countdown-minutesTo");

if (countDowns) {
  setInterval(() => {
    for (const item of countDowns) {
      const countdownTo = item.getAttribute("data-countdown-to");
      if (countdownTo) {
        const countDownDate = countdownTo.split(" +");
        let dateTo = countDownDate[0].replace(/-/g, "/");
        dateTo = new Date(dateTo).getTime();
        const now = new Date().getTime();
        const distance = dateTo - now;
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        switch (true) {
          case minutes > 1:
            item.innerHTML = `${I18n.t("generic.starts_in")} ${getMinutes(minutes + 1)}`;
            break;
          case minutes === 1:
            item.innerHTML = `${I18n.t("generic.starts_in")} ${getMinutes(minutes)}`;
            break;
          case seconds > 0:
            item.innerHTML = `${I18n.t("generic.starts_in")} ${getSeconds(seconds)}`;
            break;
          default:
            item.innerHTML = I18n.t("generic.in_live");
            break;
        }
      }
    }
  }, 1000);
}
